import { render, staticRenderFns } from "./ResearchMemberSave.vue?vue&type=template&id=cef0f570&"
import script from "./ResearchMemberSave.vue?vue&type=script&lang=js&"
export * from "./ResearchMemberSave.vue?vue&type=script&lang=js&"
import style0 from "./ResearchMemberSave.vue?vue&type=style&index=0&id=cef0f570&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports